import { theme } from 'antd';
import { ThemeConfigurationType } from '@monorepo/client-types';
import { fixedFiversToken } from './5ers-light-theme';
import {
  clientPanelDarkTheme,
  common5ersCssVars,
  commonComponentDarkTheme,
  commonComponentTheme,
  commonCssVars,
  commonDarkCssEnv,
} from './common.theme-settings';

const token = {
  colorPrimary: '#ffc806',
  colorSuccess: '#2DC0CA',
  colorWarning: '#FFD727',
  colorError: '#FF579E',
  colorInfo: '#AAB2FF',
  colorLink: '#256BE4',
};

const extraToken = {
  colorBrand: '#6677FF',
  colorAttention: '#E9C10F',
  colorActive: '#EB0064',
  colorErrorLight: 'rgb(255, 208, 228)',
  colorSecondary: '#FFD727',
};

export const DarkThemeConfigFivers: ThemeConfigurationType = {
  algorithm: theme.darkAlgorithm,
  token,
  components: {
    ...commonComponentTheme,
    ...commonComponentDarkTheme,
  },
  cssVars: {
    ...commonCssVars,
    ...commonDarkCssEnv,
    ...common5ersCssVars,
    ...token,
    ...extraToken,
    ...fixedFiversToken,
    ...clientPanelDarkTheme,
    'color-text-button-primary': '#000000',
    'dropdown-hover-bg': 'var(--mui-palette-primary-main)',
    'dropdown-selected-bg': 'var(--mui-palette-primary-main)',
  },
};
